import { Component, OnInit } from '@angular/core';
import { Unidade } from './unidade';
import { UnidadeService } from './unidade.service';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-unidades',
  templateUrl: './unidades.component.html',
  styleUrls: ['./unidades.component.css'],
  providers: [UnidadeService]

})
export class UnidadesComponent implements OnInit {

  public busy: Promise<any>;
  public unidades: Unidade[];
  public titulo: string = "Unidades";
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;

  constructor(private unidadeService: UnidadeService) { }

  getUnidades(): void {

   this.busy = this.unidadeService.getUnidades()
      .then((unidades) => this.unidades = unidades);
  }

  apagar(unidade: Unidade): void {
  //  this.toastyService.default('Hi there');

    if(confirm("Deseja realmente excluir essa unidade? Essa operação não pode ser revertida após a confirmação.")){
      this.busy = this.unidadeService.deleteUnidade(unidade)
            .then(() => this.getUnidades());
    }
  }

  ngOnInit() {
    this.getUnidades();
  }

}



// WEBPACK FOOTER //
// ./src/app/unidades/unidades.component.ts